import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ExpandLess, ExpandMore, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { useAppContext } from '../../contexts/appContext';
import CloudUpload from '@mui/icons-material/CloudUpload';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BlockIcon from '@mui/icons-material/Block';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ListIcon from '@mui/icons-material/List';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { useState } from 'react';
import { Collapse } from '@mui/material';

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      },
    },
  ],
}));

export default function SideNavbar() {
  const theme = useTheme();
  //const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { isSideNavbarOpen } = useAppContext();
  const [ajudOpen, setAjudOpen] = useState(false);
  const [ccsOpen, setCcsOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const handleClickAjud = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAjudOpen(!ajudOpen);
  };

  const handleClickCcs = (event: React.MouseEvent) => {
    event.stopPropagation();
    setCcsOpen(!ccsOpen);
  };

  const handleClickReport = (event: React.MouseEvent) => {
    event.stopPropagation();
    setReportOpen(!reportOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {/* <CssBaseline /> */}
      <Box height={30} />
      <Drawer variant="permanent" open={isSideNavbarOpen}>
        <DrawerHeader>
          <IconButton>
            {theme.direction === 'rtl' ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isSideNavbarOpen ? 'initial' : 'center',
                px: 2.5,
              }}
              onClick={() => {
                navigate('/');
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isSideNavbarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <Home />
              </ListItemIcon>
              <ListItemText
                primary="Dashboard"
                sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
              />
            </ListItemButton>

            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isSideNavbarOpen ? 'initial' : 'center',
                px: 2.5,
              }}
              onClick={isSideNavbarOpen ? handleClickCcs : undefined}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isSideNavbarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <CloudUpload />
              </ListItemIcon>
              <ListItemText
                primary="CCS"
                sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
              />
              {isSideNavbarOpen ? (
                ccsOpen ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItemButton>

            <Collapse in={ccsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ccs0001');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <CloudUpload />
                  </ListItemIcon>
                  <ListItemText
                    primary="CCS0001"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ccs0003');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <CloudUpload />
                  </ListItemIcon>
                  <ListItemText
                    primary="CCS0003"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ccs0011');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <CloudUpload />
                  </ListItemIcon>
                  <ListItemText
                    primary="CCS0011"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isSideNavbarOpen ? 'initial' : 'center',
                px: 2.5,
              }}
              onClick={isSideNavbarOpen ? handleClickAjud : undefined}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isSideNavbarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <CloudUpload />
              </ListItemIcon>
              <ListItemText
                primary="AJUD"
                sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
              />
              {isSideNavbarOpen ? (
                ajudOpen ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItemButton>

            <Collapse in={ajudOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ajud');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <BlockIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Bloqueio"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ajudWhitelist');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Whitelist"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/ajudMonitoring');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <MonitorHeartIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Monitoramento"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isSideNavbarOpen ? 'initial' : 'center',
                px: 2.5,
              }}
              onClick={isSideNavbarOpen ? handleClickReport : undefined}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isSideNavbarOpen ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText
                primary="Relátorios"
                sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
              />
              {isSideNavbarOpen ? (
                reportOpen ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItemButton>

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/reportBlocked');
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: isSideNavbarOpen ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <FindInPageIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Relatório Bloqueio"
                    sx={{ opacity: isSideNavbarOpen ? 1 : 0 }}
                  />
                </ListItemButton>
              </List>
            </Collapse>

          </ListItem>
        </List>
      </Drawer>
    </Box>
  );
}
